export const getDeliveryStatusText = (
  shippingMethodCost: string | number,
  feePerKg: number,
  freeDeliveryText: string,
  paidDeliveryText: string,
) => {
  const baseCost = Number(shippingMethodCost) || 0;
  const totalDeliveryCost = baseCost + feePerKg;

  return totalDeliveryCost > 0 ? `${paidDeliveryText} ${totalDeliveryCost} ₽` : freeDeliveryText;
};
